import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Terug',
      changePassword: 'Wachtwoord wijzigen',
      copiedVaultId: 'Gekopieerd!',
      copyVaultID: 'Kopieer Vault ID',
      create: 'Aanmaken',
      next: 'Volgende',
      notSure: 'Ik weet het niet zeker',
      signUp: 'Inschrijven',
      submit: 'Indienen',
      updatePassword: 'Wachtwoord bijwerken',
    },
    Errors: {
      createReportFailed: 'Het maken van het melding is mislukt.',
    },
    ReportStatus: {
      CLOSED: 'Gesloten',
      INVESTIGATING: 'Wordt onderzocht',
      NEW: 'Ingediend',
      READ: 'Gelezen',
    },
    general: {
      navbar: {
        caseSettings: 'Hoes instellingen',
        changePassword: 'Wachtwoord wijzigen',
        logOut: 'Uitloggen',
        notifications: 'Meldingen',
        notificationsDrawer: {
          appFileScanFailed:
            'Een bestand is niet geslaagd voor de beveiligingscontrole',
          appReportMatch: 'Uw GoTogether-record is gekoppeld',
          appReportReassigned: 'Een nieuwe casemanager is toegewezen',
          case: 'Geval',
          caseAssigned: 'Zaak aan jou toegewezen',
          caseImporterJobCompleted: {
            PartialSuccess: 'Uw zaakimport is voltooid met fouten',
            failure: 'Uw zaakimport is mislukt',
            success: 'Uw zaakimport is succesvol voltooid',
          },
          caseLinked: 'Gerelateerd geval',
          caseTeamInvite: 'Toegevoegd aan zaak',
          caseUnlinked: 'Case ontkoppeld',
          dataSanitisation: 'Rapport details bijgewerkt',
          emptyDescription: 'Controleer later op nieuwe meldingen',
          emptyTitle: 'Je bent helemaal bij',
          importId: 'Importeer ID:',
          learnMore: 'Meer leren',
          markAllAsRead: 'Markeer alles als gelezen',
          newMessage: 'Nieuwe bericht',
          newReport: 'Nieuw rapport ontvangen',
          permissionRemoved: 'Verwijderd uit zaak',
          postSSubmissionFile: 'Bewijsbestand(en) toegevoegd',
          report: 'Rapport',
          reportAssigned: 'Rapport toegewezen aan jou',
          reportStatusChange: 'Rapportstatus gewijzigd',
          reporterAnonymised: 'Uw gegevens zijn geanonimiseerd',
          reporterReportSubmitted: {
            subtitle: 'We raden aan een kopie van uw rapport op te slaan',
            title: 'Ingediend rapport',
          },
          mitigationPlanReminder: 'Goedkeuring van het mitigatieplan vereist',
          staleCase: 'Niet afgehandelde zaak',
        },
        privacyStatement: 'Privacyverklaring',
        reporter: {
          myReports: 'Mijn rapporten',
        },
        settings: 'Instellingen',
        technicalSupport: 'Technische ondersteuning',
        title: 'Account',
      },
      time: {
        day: 'Dag',
        days: 'Dagen',
        hour: 'Uur',
        hours: 'Uren',
        minute: 'Minuut',
        minutes: 'Notulen',
        second: 'Seconde',
        seconds: 'Seconden',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anoniem',
        autoTranslate: 'Auto-translate staat standaard uitgeschakeld.',
        backToMessages: 'Terug naar berichten',
        caseSettings: 'Case-instellingen.',
        changeInProfile:
          'Als u deze instelling wilt wijzigen, kunt u dit doen in uw profiel',
        deletedByMessage: 'Verwijderd door {{author}}',
        deletedMessageLabel: 'Dit bericht werd verwijderd',
        description:
          'Wanneer automatische vertaling is ingeschakeld, worden alle rapportberichten\n          automatisch vertaald met behulp van AI gebaseerd op de standaardtaal\n          die is geselecteerd in uw browser.',
        descriptionSecondHalf:
          'De originele versie van alle berichten wordt altijd bewaard en kan worden gevonden in de chat.',
        messagePlaceholder: 'Begin met typen...',
        messageSettings: 'Berichtinstellingen.',
        originalMessages: 'Origineel',
        showMoreBanner: 'Leer meer over automatische vertalingen',
        titlev2: 'Lees alle berichten in je voorkeurstaal.',
        translatedMessageLabel: 'Vertaald Bericht',
        translatedMessages: 'Vertaald',
        understood: 'Begrepen',
      },
      Country: {
        description: 'In welk land bent u gevestigd?',
        header: 'In welk land bent u gevestigd?',
        noOptions: 'Geen landen gevonden',
        other: 'Anders',
        placeholder: 'Zoek een land...',
      },
      CreatePublicReport: {
        createReport: 'Een nieuwe melding aanmaken',
        helpPage: 'Ga naar onze hulppagina',
        loginToOpr: 'Meld aan om rapporten te volgen',
        or: 'of',
        passwordPlaceholder: 'Wachtwoord invoeren',
        phoneNumberLoginFailed:
          'Aanmelden mislukt, telefoonnummer/pincode onjuist',
        phoneNumberPlaceholder: 'Voer uw telefoonnummer in',
        phoneNumberTooltip:
          'Voer het telefoonnummer in dat je gebruikt hebt om contact op te nemen met VaultTalk',
        pinPlaceholder: 'Voer pincode in',
        reportIntroductionParagraph1:
          'Bij het melden van een incident, worden er een paar vragen gesteld om u te helpen bij het documenteren van uw ervaring.',
        reportIntroductionParagraph2:
          'Voordat u indient, heeft u de optie om anoniem te blijven om uw privacy te beschermen.',
        reportIntroductionParagraph3:
          'Nadat u heeft ingediend, kunt u op elk moment inloggen om de voortgang van uw rapport te bekijken en te praten met een casemanager.',
        reportIssue: 'Een probleem melden',
        usernameLoginFailed:
          'Aanmelding mislukt, gebruikersnaam/wachtwoord onjuist',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired: 'Relatie tot het bedrijf is vereist',
            reportedCategoryRequired: 'Gerapporteerde categorie is vereist',
          },
        },
        vaultId: 'Vault ID',
        vaultIdPlaceholder: 'Voer uw e-mail of Vault ID in',
        vaultIdTooltip:
          'Voor anonieme rapporten is de Vault-ID alfanumeriek. Als het rapport niet anoniem was, is de Vault-ID uw e-mailadres.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Uw wachtwoord',
        yourPhoneNumber: 'Uw Telefoonnummer',
        yourPin: 'Uw 6-cijferige pin',
        yourVaultId: 'Uw Vault ID',
      },
      CustomHeader: {
        companyLogo: 'Bedrijfslogo',
        openReporting: 'Melding openen',
        userSettings: 'Gebruikersinstellingen',
      },
      Date: {
        approximateDescription:
          'Weet u nog ongeveer de datum waarop de gebeurtenis plaatsvond?',
        approximatePlaceholder:
          'Voorbeeld: 6 maanden geleden/vorig jaar/afgelopen november',
        cancel: 'annuleren',
        clear: 'wissen',
        description: 'Weet u nog de datum waarop de gebeurtenis plaatsvond?',
        header: 'Op welke dag is het gebeurd?',
        ok: 'ok',
        placeholder: 'Voorbeeld: 21 juni 2020',
      },
      Description: {
        whatHappened: 'Wat is er gebeurd?',
        whatHappenedPlaceholder: 'Gebruik uw eigen woorden...',
        whatHappenedText: 'Beschrijf in uw eigen woorden wat er is gebeurd',
      },
      Details: {
        disclaimer:
          'Deze gegevens zullen worden bekendgemaakt met uw rapport. Als u anoniem wilt blijven, zorg er dan voor dat ze geen identificerende informatie bevatten.',
        emailPlaceholder: 'E-mailadres (optioneel)',
        fullNamePlaceholder: 'Volledige naam (optioneel)',
        header: 'Uw gegevens',
        nonAnonSubtitle:
          'Geef alstublieft uw naam of een e-mailadres op. Als u meldingen over dit rapport wilt ontvangen, voeg dan hieronder een geschikt e-mailadres toe.',
        nonOptionalEmailPlaceholder: 'E-mail',
        nonOptionalFullNamePlaceholder: 'Volledige naam',
        subtitle:
          'Als u meldingen over dit rapport wilt ontvangen, voeg dan hieronder een geschikt e-mailadres toe.',
      },
      Emotion: {
        description: 'Hoe voelde u zich erdoor? Wat was de impact?',
        header: 'Wat was de impact?',
        placeholder: 'Begin met het invoeren...',
      },
      Evidence: {
        addedHeading: 'Toegevoegd',
        deletedMessage: 'werd verwijderd',
        deletedStatus: 'Verwijderd',
        failedToOpenFileMessage:
          'Het openen van het bestand is mislukt. Probeer het alstublieft opnieuw.',
        fileStatuses: {
          infectedUpload: 'Gemarkeerd door beveiligingscontrole',
          passedUpload: 'Veiligheidscontrole doorstaan',
          pendingUpload: 'Veiligheidscontrole bezig',
          readyForDownload: 'Klaar om te downloaden',
        },
        mobileErrorMessage:
          'Gemarkeerde bestanden: stuur een bericht naar uw casemanager',
        nameHeading: 'Naam',
        statusHeading: 'Status',
        tableTitle: 'Bewijs',
        webErrorMessage:
          'Gemarkeerde bestanden: Als uw bestand(en) gemarkeerd is/zijn, gelieve dan een bericht te sturen naar de casemanager.',
      },
      FileUpload: {
        addFiles: 'Bestanden toevoegen',
        addMoreFiles: 'Voeg meer bestanden toe',
        confirm: 'Bevestigen',
        description:
          'Het toevoegen van bestanden als bewijs kan de efficiëntie van de oplossing door uw casemanager ondersteunen. Houd rekening met de inhoud van het bestand (inclusief bestandsmetadata) als u anoniem wilt blijven, en respecteer de rechten van andere individuen en de toepasselijke wetten.',
        dragDrop: 'Sleep bestanden hierheen of',
        errorMessage:
          'Bestand(en) mislukt vanwege een netwerkfout. Klik hieronder om uw casemanager om hulp te vragen',
        fileLimit: 'Elke bestandsgrootte limiet: 100MB',
        fileUploadLimitText: 'Je kunt slechts 10 bestanden uploaden',
        header: 'Voeg bewijs toe',
        helpArticle: 'hulp artikel',
        highlighted: 'bestanden doorbladeren',
        information: 'Ondersteunde bestandstypes',
        moreInformation:
          'Voor meer info, zie dit alstublieft <a>hulp artikel</a>',
        postSubmissionErrorMessage:
          "We konden uw bestanden niet uploaden vanwege een systeemfout. Selecteer alstublieft opnieuw 'bevestigen'.",
        tooltipAudio: 'Audio:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Documenten:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Afbeeldingen:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Tekst:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Het bestand is te groot',
          invalidFileType: 'Niet-ondersteund bestandstype: {{extension}}',
          systemError: 'Systeemfout',
          tooManyFiles: 'Maximum aantal bestanden is {{maxFiles}}',
        },
        uploadFiles: 'Bestanden uploaden',
      },
      Loading: {
        loading:
          'Even geduld terwijl we uw rapport indienen bij een casemanager...',
        postSubmissionLoading:
          'Even geduld terwijl we uw bestand(en) indienen...',
      },
      Location: {
        description: 'Waar is het gebeurd?',
        header: 'Waar is het gebeurd?',
        placeholder: 'Voorbeeld: op kantoor',
      },
      MessageListBox: {
        messageCaseManager: 'Bericht sturen naar Casemanager',
        report: 'Melding {{displayReportId}}{{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Vertaling uitgeschakeld',
        enableTranslationLabelEnabled: 'Vertaling ingeschakeld',
        enableTranslationsDescription:
          'Schakel automatische vertalingen in en lees alle rapportberichten in uw voorkeurstaal. De vertaalde taal is gebaseerd op de taal die op uw apparaat is geselecteerd.',
        enableTranslationsHeader:
          'Schakel automatische vertalingen in voor rapportberichten',
        enableTranslationsSubDescriptionv2:
          'U kunt schakelen tussen de vertaalde en originele taal in elke chat.',
        updateTranslationFailed: 'Update van vertaling mislukt',
        updateTranslationSuccess: 'Vertaalinstellingen succesvol bijgewerkt',
      },
      Password: {
        changePasswordHeader: 'Wachtwoord wijzigen',
        createNewPassword: 'Maak een nieuw wachtwoord aan',
        createPasswordHeader: 'Uw wachtwoord',
        currentPasswordPlaceholder: 'Huidig wachtwoord invoeren',
        description:
          'Een geldig wachtwoord moet minimaal 9 tekens lang zijn en een hoofdletter en een cijfer bevatten',
        enterCurrentPassword: 'Uw huidig wachtwoord invoeren',
        forgottenPasswordInstructions:
          'Voer uw alfanumerieke Vault ID (niet uw e-mailadres) en e-mailadres in om uw wachtwoord te resetten.',
        newDescription:
          'Maak een sterk wachtwoord om uw account veilig te houden. Begin met typen om de richtlijnen hieronder te zien.',
        passwordPlaceholder: 'Een wachtwoord aanmaken',
        passwordResetRequestedDescription:
          'Als uw Vault ID bestaat in ons systeem, ontvangt u een e-mail met instructies om uw wachtwoord te resetten.',
        passwordResetRequestedHeader:
          'Link voor het resetten van het wachtwoord aangevraagd',
        reenterPlaceholder: 'Het wachtwoord opnieuw invoeren',
        subtitle:
          'Maak een wachtwoord aan om deze melding in te dienen en er in de toekomst toegang toe te krijgen',
        yourVaultId: 'Uw Vault ID',
        yourVaultIdPlaceholder: 'Voer uw Vault ID in (bijv. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Meldt u een bepaalde persoon of meerdere personen? Heeft u een naam of kunt u ze beschrijven?',
        header: 'Betrokken personen',
        placeholder:
          'Begin met typen en gebruik een komma om meerdere namen of beschrijvingen toe te voegen',
      },
      PoweredByVault: 'Powered by {{company}}',
      PrivacyStatement: 'Product Privacyverklaring',
      PublicMessageList: {
        myMessages: 'Mijn berichten',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Bewijs toegevoegd aan bestaand rapport',
        backToReportId: 'Terug naar rapport ID: {{reportId}}',
        description:
          'Het toevoegen van bestanden als bewijs kan de efficiëntie van de oplossing door uw casemanager ondersteunen. Overweeg de inhoud van het bestand (inclusief bestandsmetadata) als u anoniem wilt blijven en respecteer de rechten van andere personen en toepasselijke wetten. Voor meer informatie, zie dit <a>hulp artikel</a>',
        header: 'Voeg extra bewijs toe aan het rapport',
        vaultTalkOpenCaseHeader: 'Voeg bewijs toe aan je rapport',
      },
      PublicReport: {
        anonymous: 'Anoniem',
        backToReports: 'Terug naar meldingen',
        skipped: 'Overgeslagen',
      },
      PublicReportCard: {
        addEvidence: 'Voeg extra bewijs toe',
        messageCaseManager: 'Bericht sturen naar Casemanager',
        reportId: 'Melding-ID:',
        submitted: 'Ingediend',
        vaultTalkClosedCaseCTA: 'Bekijk Bewijs',
        vaultTalkOpenCaseCTA: 'Voeg Bewijs Toe',
        viewAdditionalEvidence: 'Bekijk extra bewijs',
        viewReport: 'Melding bekijken',
      },
      PublicReportsList: {
        reportingSystem: 'Meldsysteem',
      },
      Question: {
        placeholder: 'Begin met typen...',
        question: 'Geef details',
        questionText: 'Deel a.u.b. uw bezorgdheid, update of vraag met ons.',
      },
      Relationship: {
        header: 'Uw relatie met de organisatie',
        tellUsAbout: 'Vertel ons over uw relatie met de organisatie.',
      },
      ResponsiveNavMenu: {
        messages: 'Mijn berichten',
        reports: 'Mijn verslagen',
      },
      Site: {
        description: 'Op welke locatie bent u gevestigd?',
        header: 'Op welke locatie bent u gevestigd?',
        noOptions: 'Geen locaties gevonden',
        other: 'Anders',
        placeholder: 'Zoek naar een locatie...',
      },
      SpamPuzzle: {
        dialog: 'Los deze puzzel op om verder te gaan',
      },
      SubmissionTypes: {
        reportIssue: 'Selecteer een categorie',
        whatType: 'Selecteer de categorie die het best uw rapport beschrijft',
      },
      SubmitSuccess: {
        category: '<bold>Categorie:</bold> {{categorie}}',
        country: '<bold>Land:</bold> {{country}}',
        dateSubmitted: '<bold>Ingediende datum:</bold> {{date}}',
        recordYourVaultID: 'Onthoud deze informatie voor inloggen',
        successInformation: 'Meer informatie',
        successMessage:
          'Uw rapport is ingediend en is klaar voor beoordeling. Eventuele bijgevoegde bestanden die aandacht vereisen, worden gemarkeerd bij het inloggen. Log hieronder in om rapportupdates te bekijken en berichten te sturen naar uw case manager.',
        successSanitationMessage:
          'Bewaar een kopie voor uw administratie en bewaar uw Vault-ID veilig - u heeft het nodig om updates te raadplegen en uw dossierbeheerder te berichten.',
        successSanitationTagline:
          'Uw rapport is ingediend en veilig opgeslagen.',
        successThankYou: 'Dank u voor uw rapport!',
        viewReport: 'Rapport bekijken',
      },
      Time: {
        approximateDescription:
          'Weet u nog ongeveer de tijd waarop de gebeurtenis plaatsvond?',
        approximatePlaceholder: "Voorbeeld: 's morgens, in de namiddag",
        description: 'Weet u nog de tijd waarop de gebeurtenis plaatsvond?',
        header: 'Hoe laat is het gebeurd?',
        invalidTime: 'Tijdnotatie moet HH:MM zijn',
      },
      UserSettingsDialog: {
        changePassword: 'Wachtwoord wijzigen',
        closeDialog: 'Dialoog sluiten',
        logout: 'Uitloggen',
        messageSettings: 'Berichtinstellingen',
        userSettings: 'Gebruikersinstellingen',
      },
      Witnesses: {
        description:
          'Heeft u het aan iemand anders verteld of heeft iemand gezien wat er is gebeurd?',
        header: 'Waren er getuigen?',
        placeholder: 'Begin met het invoeren...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Verstuur bericht',
        title: 'Bericht Casemanager',
        translationHeader: 'Kom meer te weten over automatische vertalingen',
      },
      ReportCard: {
        addEvidence: 'Voeg bewijs toe',
        submissionModeVia: 'via {{indieningsmodus}}',
        viewEvidence: 'Bekijk bewijs',
      },
      ReportList: {
        yourReports: 'Uw Rapporten',
      },
      ReportingActivate: {
        buttonText: 'Doorgaan',
        description:
          'Als uw organisatie u heeft geregistreerd voor een account, sturen we u een e-mail met instructies om de setup te voltooien.',
        emailInput: 'E-mail',
        header: 'Voer uw werk e-mail in',
        successAccount:
          'Als uw organisatie u heeft geregistreerd voor een account, sturen we u een e-mail met instructies om de installatie te voltooien.',
        successEmail:
          'Als u het niet onmiddellijk ziet, wacht dan een paar minuten en vernieuw uw e-mailinbox.',
        successHeading: 'Dank u',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Voeg bewijs toe aan je rapport',
        descriptionText:
          'Het toevoegen van bestanden als bewijsmateriaal kan de efficiëntie van de oplossing door uw case manager ondersteunen. Houd rekening met de inhoud van het bestand (inclusief bestandsmetadata) als u anoniem wilt blijven, en respecteer de rechten van andere personen en de toepasselijke wetten. Voor meer informatie, zie dit <a>hulp artikel</a>',
        emptyMessage: 'Geen extra bewijsmateriaal geüpload',
      },
      ReportingChangePassword: {
        back: 'Terug',
        description:
          'Maak een sterk wachtwoord om uw account veilig te houden. Begin met typen om de richtlijnen hieronder te zien.',
        errorToast: 'Kan geen wachtwoord aanmaken, ongeldig token.',
        header: 'Wachtwoord wijzigen',
        incorrectCurrentPassword:
          'Het huidige wachtwoord is verkeerd. Controleer het alstublieft en probeer opnieuw.',
        invalidToken: 'Ongeldig token',
        passwordUpdated: 'Wachtwoord bijgewerkt',
        passwordUpdatedDescription:
          'Uw wachtwoord is succesvol bijgewerkt. Bedankt voor het nemen van deze stap om uw gegevens veilig te houden!',
        passwordUsedBefore: 'Hergebruik van wachtwoord niet toegestaan',
        passwordUsedBeforeDescription:
          'Voor uw veiligheid kunt u geen van uw laatste zes wachtwoorden opnieuw gebruiken. Kies alstublieft een nieuw, uniek wachtwoord om uw account veilig te houden en probeer het opnieuw.',
        toastDescription:
          'Uw wachtwoord is succesvol bijgewerkt. Bedankt voor het nemen van deze stap om uw gegevens veilig te houden!',
        toastMessage: 'Wachtwoord bijgewerkt',
        updatePasswordCTA: 'Wachtwoord bijwerken',
      },
      ReportingConnect: {
        cancelButton: 'Annuleren',
        connectButton: 'Verbinden',
        disclaimer:
          'Het koppelen van uw Slack-account aan uw Vault-account zorgt voor een veilige en privéverbinding.<br /><br />Door te koppelen, kunt u wangedrag melden of een vraag rechtstreeks binnen Slack stellen. U heeft altijd de optie om anoniem te rapporteren na het verbinden. Uw privacy en veiligheid zijn onze hoogste prioriteiten.',
        heading:
          'Vault Platform vraagt toestemming om toegang te krijgen tot uw {{organisationName}} Slack-account',
        listHeading: 'Wat zal Vault kunnen doen?',
        permissionIdentity: {
          extraInfo:
            'Vault zal de mogelijkheid hebben om de identiteit van uw Slack-gebruiker te bekijken',
          heading: 'Bekijk informatie over de identiteit van een gebruiker',
        },
        permissionNotifications: {
          extraInfo:
            'Vault kan meldingen naar je Slack-account sturen, met betrekking tot eventuele updates voor een ingediend rapport of vraag.',
          heading: 'Stuur je meldingen',
        },
        permissionOverview: {
          extraInfo:
            'Vault zal een overzicht van alle inzendingen tonen op de startpagina',
          heading: 'Overzicht van inzendingen',
        },
        permissionSubmitReport: {
          extraInfo:
            'Dit zal Vault toestemming geven om een rapport in te dienen of een vraag te stellen, rechtstreeks aan uw organisatie, vanuit Slack',
          heading: 'Dien een rapport of vraag in namens u',
        },
        successfulConnectionDescription:
          'Uw Vault-account en Slack-account zijn nu met elkaar verbonden. U kunt nu dit tabblad sluiten en terugkeren naar Slack.',
        successfulConnectionHeading: 'Succesvol verbonden',
        unsuccessfulConnectionDescription:
          'Er is iets misgegaan. Sluit deze tab alstublieft en ga terug naar Slack om het opnieuw te proberen.',
        unsuccessfulConnectionHeading: 'Verbinding mislukt',
      },
      ReportingForgotPassword: {
        description:
          'Voer het e-mailadres in dat is gekoppeld aan uw account en we sturen u een link om uw wachtwoord opnieuw in te stellen.',
        heading: 'Vergeten wachtwoord',
        invalidTokenError: 'Kan geen wachtwoord aanmaken, ongeldig token.',
        passwordReuseError: 'Hergebruik van wachtwoord niet toegestaan',
        passwordReuseErrorDescription:
          'Voor uw veiligheid kunt u geen van uw laatste zes wachtwoorden hergebruiken. Kies een nieuw, uniek wachtwoord om uw account veilig te houden en probeer het opnieuw.',
        sendLink: 'Stuur reset link',
        sendLinkFailure: 'Er is iets misgegaan',
        sendLinkFailureDescription:
          'Keer terug naar de <a>Reporter Hub</a> en probeer opnieuw. Als het probleem aanhoudt, neem dan contact met ons op via <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Link voor het resetten van het wachtwoord verzonden',
        sendLinkSuccessDescription:
          'We hebben een link om uw wachtwoord te resetten gestuurd naar {{email}}',
        updatePasswordSuccess: 'Wachtwoord bijgewerkt',
        updatePasswordSuccessDescription:
          'Uw wachtwoord is succesvol bijgewerkt. Bedankt voor het nemen van deze stap om uw gegevens veilig te houden!',
      },
      ReportingLogin: {
        accountFrozen: 'Account is bevroren',
        accountLocked:
          'Er is te vaak geprobeerd om in te loggen. Het account is tot 1 uur vergrendeld. Het is niet mogelijk om gedurende deze tijd het wachtwoord te resetten.',
        accountLockedPermanently:
          'Uw account is vergrendeld. Gebruik wachtwoord resetten om opnieuw toegang te krijgen of neem contact op met uw systeembeheerder voor verdere hulp.',
        createAccountCTA: 'Registreer voor een account',
        currentPassword: 'Huidig wachtwoord',
        emailLabel: 'Uw e-mail',
        forgotPassword: 'Je wachtwoord vergeten?',
        loginButton: 'Inloggen',
        newPasswordPlaceholder: 'Nieuw wachtwoord',
        passwordFailMessage:
          'Ga terug naar de Vault App in Slack en probeer opnieuw. Als het probleem blijft bestaan, neem dan contact met ons op via techsupport@vaultplatform.com',
        passwordFailTitle: 'Er is iets misgegaan',
        passwordLabel: 'Je Wachtwoord',
        passwordPlaceholder: 'Voer uw wachtwoord in',
        passwordResetRequired: 'Wachtwoord reset vereist',
        passwordSuccessfullySetMessage:
          'Ga terug naar de Vault App in Slack en authenticeer met je nieuwe wachtwoord om verder te gaan waar je gebleven was.',
        passwordSuccessfullySetTitle: 'Wachtwoord succesvol ingesteld',
        reenterPlaceholder: 'Voer het wachtwoord opnieuw in',
        title: 'Reporter Hub',
        tooltip:
          'Als je nog nooit een wachtwoord hebt ingesteld voor de Vault-app, volg dan hier om te beginnen. Als je je wachtwoord bent vergeten, gebruik dan de link "Wachtwoord vergeten" hieronder.',
        usernameLoginFailed:
          'Inloggen mislukt, gebruikersnaam of wachtwoord incorrect',
      },
      ReportingReset: {
        failureDescription:
          'Ga terug naar de Vault App in Slack en probeer opnieuw. Als het probleem aanhoudt, neem dan contact met ons op via <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Er ging iets mis',
        successDescription:
          'Ga terug naar de Vault-app in Slack en verifieer jezelf met je nieuwe wachtwoord om verder te gaan waar je gebleven was.',
        successHeading: 'Wachtwoord succesvol ingesteld',
      },
      noReports: {
        description:
          'Alle ingediende rapporten worden hier weergegeven. Leer meer over de manieren waarop je een rapport kunt indienen in',
        descriptionHelpArticle: 'dit hulp artikel',
        errorDescription:
          'We hebben moeite om uw rapporten te laden. Probeer de pagina te vernieuwen.',
        errorDescriptionSecondary:
          'Als dat niet werkt, neem dan contact met ons op via',
        errorTitle: '⚠️ Oeps, er is iets misgegaan',
        title: 'Je hebt nog geen rapporten',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Schakel automatische vertalingen in en lees alle rapportberichten in uw voorkeurstaal. De vertaalde taal is gebaseerd op de taal die is geselecteerd op uw apparaat.',
          autoTranslationDescription2:
            'U kunt in elke chat wisselen tussen de vertaalde en de originele taal.',
          autoTranslationTitle:
            'Schakel automatische vertalingen in voor rapportberichten',
          header: 'Berichtinstellingen',
          subHeader: 'Configureer hoe berichten worden weergegeven',
        },
        notificationSettings: {
          emailDescription:
            'Ontvang e-mailmeldingen voor belangrijke updates van uw rapporten',
          emailTitle: 'E-mailmeldingen',
          header: 'Notificatie Instellingen',
          subHeader: 'Configureer hoe u meldingen ontvangt',
        },
        title: 'Instellingen',
        updatedSettingsFailure: 'Update van uw instellingen is mislukt',
        updatedSettingsSuccess: 'Uw instellingen zijn succesvol bijgewerkt',
      },
    },
    validators: {
      passwordLength: 'Het wachtwoord moet minimaal 9 tekens lang zijn',
      passwordLowercase:
        'Het wachtwoord moet minimaal 1 kleine letter bevatten',
      passwordMissMatch:
        'De wachtwoord- en bevestigingsvelden moeten overeenkomen.',
      passwordNumeric: 'Het wachtwoord moet minimaal 1 cijfer bevatten',
      passwordUppercase: 'Het wachtwoord moet minimaal 1 hoofdletter bevatten',
    },
    validatorsNew: {
      passwordLength: 'Tussen 10 en 30 tekens',
      passwordLowercase: 'Minstens één kleine letter',
      passwordMissMatch: 'Wachtwoorden komen niet overeen',
      passwordNumeric: 'Minstens één nummer',
      passwordSpecialCharacter: 'Minstens één speciaal teken',
      passwordUppercase: 'Minstens één hoofdletter',
    },
  },
};

export default translations;
